import reconcilePersistedState from "../../helpers/reconcilePersistedState";

type State = {
    authorized: boolean,
    authStarted: boolean,
    email: string,
    first_name: string,
    last_name: string,
}

const initialState: State = {
    authorized: false,
    authStarted: false,
    email: '',
    first_name: '',
    last_name: ''
}

export function auth(state: State = initialState, action: Action): State {
    switch (action.type) {
        case 'SET_AUTH_STARTED':
            return { ...state, authStarted: action.value };
        case 'LOGIN':
            return { ...state, authorized: true, email: action.email, first_name: action.first_name, last_name: action.last_name };
        case 'LOGOUT':
            return { ...state, authorized: false, first_name: '', last_name: '', email: '' };
        case 'RECONCILE_PERSISTED_STATE':
            return reconcilePersistedState(state, initialState);
        default:
            return state;
    }
}
